import { ReactNode } from 'react';
import { DexResultsContext } from './dex-results-context';
import { useIntegratedDexResults } from './use-integrated-dex-results';

export function DexResultsProvider({ children }: { children: ReactNode }) {
    const integratedDexResults = useIntegratedDexResults();
    return (
        <DexResultsContext.Provider value={integratedDexResults}>
            {children}
        </DexResultsContext.Provider>
    );
}
